// converts mock-data to the string representation received from within benefitsolver
const toEncodedString = object => {
	return encodeURIComponent(JSON.stringify(object)).replace(new RegExp('%', 'g'), '\\x');
};

const generateRoles = (coNum, inRoles) => {
	let rolesArray = inRoles;
	if (!Array.isArray(inRoles)) {
		rolesArray = [inRoles];
	}

	return rolesArray.map(role => {
		return {
			co_num: coNum,
			ar_id: role,
			as_id: 'BS',
			active: true
		};
	});
};

const rolesToString = object => {
	const roles = {
		memberRoles: object
	};
	return toEncodedString(roles);
};

const generateRolesString = (coNum, inRoles) => {
	return rolesToString(generateRoles(coNum, inRoles));
};

const CustomerTestUtils = {
	toEncodedString,
	generateRoles,
	rolesToString,
	generateRolesString
};

export default CustomerTestUtils;
